let popUp = document.querySelector(".info-popup");
let popUpMobile = document.querySelector(".info-popup-mobile");
let infoTarget = document.querySelector(".info-target");
let infoTargetMobile = document.querySelector(".info-target-mobile");

// Проверка на существование и добавление обработчика для infoTarget
if (infoTarget && popUp) {
    infoTarget.addEventListener("mouseenter", () => {
        let height = popUp.offsetHeight - 20;
        popUp.style.transform = "translate(0," + height + "px)";
        popUp.classList.add("show");
    });

    infoTarget.addEventListener("mouseleave", () => {
        popUp.classList.remove("show");
    });
}

// Проверка на существование и добавление обработчика для infoTargetMobile
if (infoTargetMobile && popUpMobile) {
    document.addEventListener('click', e => {
        if (!infoTargetMobile.contains(e.target)) {
            popUpMobile.classList.remove('show');
        }
    });

    infoTargetMobile.addEventListener("click", () => {
        let height = popUpMobile.offsetHeight;
        let translateX = window.innerWidth > 450 ? "-20%" : "0";
        popUpMobile.style.transform = "translate(" + translateX + "," + height + "px)";
        popUpMobile.classList.add("show");
    });
}
